module.exports = __webpack_public_path__ + "icon_chart.f35a1ce7c89118ffdc18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_chart.svg
// module id = ./src/assets/img/icon_chart.svg
// module chunks = main